import React, { Component } from 'react'
import AppBar from 'material-ui/AppBar'
import IconButton from 'material-ui/IconButton'
import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'

class QuickActions extends Component {
  render() {
    return (
      <IconMenu
        iconButtonElement={
          <IconButton iconStyle={{
            color: '#fff'
          }}>
            <MoreVertIcon />
          </IconButton>
        }
        targetOrigin={{
          horizontal: 'right',
          vertical: 'top'
        }}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'top'
        }}
      >
        <MenuItem onTouchTap={this.props.signOut} primaryText='Sign out' />
      </IconMenu>
    )
  }
}

class AppHeader extends Component {
  render() {
    return (
      <AppBar
        title={this.props.title}
        titleStyle={{
          textAlign: 'left'
        }}
        style={{
          position: 'fixed',
          top: '0',
          width: this.props.navOpen && screen.width > 768 ? 'calc(100% - 256px)' : '100%'
        }}
        iconElementRight={<QuickActions signOut={this.props.signOut} />}
        onLeftIconButtonTouchTap={() => this.props.toggleNav()}
      />
    )
  }
}

export default AppHeader



// WEBPACK FOOTER //
// ./src/components/AppHeader.js